import { useCallback, useState } from "react"
import '../assets/css/Prijava.css'
import { Alert, Button, Form, Input, Modal } from "antd"
import { useModalContext } from "../context/ModalContext"
import noRefreshClient, { setMessageBasedOnErrorMessage } from "../services/api/NoRefreshClient"
import { containsANumberAndUppercaseLetter, containsOnlyLettersNumbersAndUnderscore } from "../services/CommonService"
import { MODAL_DESCRIPTION_SUCCESS_REGISTRATION, MODAL_MESSAGE_SUCCESS_REGISTRATION, MODAL_TYPE_SUCCESS } from "../HistoriografijaConstants"

function Registracija() {
    const [showWarning, setShowWarning] = useState(false)
    const [error, setError] = useState(String)
    const { displayMessageModalWithParameters, displayGenericErrorModal, resetModalContext } = useModalContext()
    const [form] = Form.useForm()

    const submitForm = useCallback((values) => {
        setShowWarning(false)
        form.validateFields({validateOnly: true})
            .then(async () => {
                var formData = new FormData();
                formData.append("firstName", values.firstName)
                formData.append("lastName", values.lastName)
                formData.append("email", values.email)
                formData.append("username", values.username)
                formData.append("password", values.password)
                formData.append("confirmPassword", values.confirmPassword)
                
                return noRefreshClient.post('register', formData)
                .then(data => {
                    if (data.status === 200 && data.data.id) {
                        displayMessageModalWithParameters(MODAL_MESSAGE_SUCCESS_REGISTRATION, MODAL_DESCRIPTION_SUCCESS_REGISTRATION, MODAL_TYPE_SUCCESS)
                    } else {
                        displayGenericErrorModal()
                    }
                })
                .catch(error => {
                    setMessageBasedOnErrorMessage(error)
                    setError(error.message)
                    setShowWarning(true)
                })
            })
    }, [setShowWarning, form, displayMessageModalWithParameters, displayGenericErrorModal, setError])

    const onClose = useCallback(() => {
        resetModalContext()
    }, [resetModalContext])

    return (
        <Modal 
            open={true}
            footer={null}
            onCancel={onClose}
            centered
        >
            <div className="Prijava">
                <div className="PrijavaForm">
                    <Form form={form} onFinish={submitForm} className="Form" noValidate scrollToFirstError>
                        <h2 className="FormTitle">REGISTRACIJA</h2>

                        <Form.Item name="firstName"
                            className="formItem"                      
                            rules={[
                                {
                                    required: true,
                                    message: 'Ime je obavezno polje',
                                },
                                {
                                    min: 2,
                                    message: 'Ime je prekratko'
                                },
                                {
                                    max: 63,
                                    message: 'Ime je predugo'
                                }
                            ]}>
                            <Input placeholder="Ime" className="inputField" />
                        </Form.Item>

                        <Form.Item name="lastName"
                            className="formItem"                      
                            rules={[
                                {
                                    required: true,
                                    message: 'Prezime je obavezno polje',
                                },
                                {
                                    min: 2,
                                    message: 'Prezime je prekratko'
                                },
                                {
                                    max: 63,
                                    message: 'Prezime je predugo'
                                }
                            ]}>
                            <Input placeholder="Prezime" className="inputField" />
                        </Form.Item>

                        <Form.Item name="email"
                            className="formItem"                    
                            rules={[
                                {
                                    required: true,
                                    message: 'Email je obavezno polje',
                                },
                                {
                                    type: 'email',
                                    message: 'Email adresa nije u ispravnom formatu',
                                    validateTrigger: 'onBlur'
                                }
                            ]}>
                            <Input placeholder="Email" className="inputField" type="email"/>
                        </Form.Item>

                        <Form.Item name="username"
                            className="formItem"               
                            rules={[
                                () => ({
                                    validator(_, value) {
                                        if (value) {
                                            if (value.length !== 0 && value.length < 2) {
                                                return Promise.reject(new Error('Korisničko ime je prekratko'))
                                            } else if (value.length > 30) {
                                                return Promise.reject(new Error('Korisničko ime je predugo'))
                                            } else if (!containsOnlyLettersNumbersAndUnderscore(value)) {
                                                return Promise.reject(new Error('Korisničko ime može da sadrži samo standardna slova, brojeve i znak _'))
                                            }
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(new Error('Korisničko ime je obavezno polje'))
                                    },
                                })
                            ]}
                        >
                            <div>
                                <Input placeholder="Korisničko ime" className="inputField" />
                                <p className="field-description">Dozvoljena su slova, brojevi i znak _, bez specijalnih karaktera</p>
                            </div>
                        </Form.Item>

                        <Form.Item name="password"
                            className="formItem"                         
                            rules={[
                                () => ({
                                    validator(_, value) {
                                        if (value) {
                                            if (value.length !== 0 && value.length < 8) {
                                                return Promise.reject(new Error('Lozinka je prekratka. Potrebno je da ima najmanje 8 karaktera'))
                                            } else if (value.length > 30) {
                                                return Promise.reject(new Error('Lozinka je preduga'))
                                            } else if (!containsANumberAndUppercaseLetter(value)) {
                                                return Promise.reject(new Error('Lozinka treba da sadrži najmanje 1 broj i najmanje 1 veliko slovo'))
                                            }
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(new Error('Lozinka je obavezno polje'))
                                    },
                                })
                            ]}
                        >
                            <div>
                                <Input.Password
                                    type="password"
                                    placeholder="Lozinka"
                                    className="inputField"
                                />
                                <p className="field-description">Lozinka treba da sadrži najmanje 8 karaktera, 1 broj, 1 veliko slovo</p>
                            </div>
                        </Form.Item>

                        <Form.Item name="confirmPassword"
                            className="formItem"                         
                            rules={[
                                {
                                    required: true,
                                    message: 'Potvrdite lozinku',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Lozinke se ne slažu'));
                                    },
                                })
                        ]}>
                            <Input.Password
                                type="password"
                                placeholder="Potvrdite lozinku"
                                className="inputField"
                            />
                        </Form.Item>

                        {showWarning ?
                            <Alert
                                message="Greška"
                                description={error}
                                type="error"
                                style={{ marginBottom: '20px', marginTop: '20px' }}
                                showIcon
                            /> : null
                        }

                        <Form.Item>
                            <Button htmlType="submit" className="login-form-button custom-button primaryButton">
                                KREIRAJTE RAČUN
                            </Button>
                        </Form.Item>

                    </Form>
                </div>
            </div>
        </Modal>
    )
}

export default Registracija